module.exports = __webpack_public_path__ + "img/mikey.2d9e32c6.jpeg";